import React, { Component } from 'react';
import TableParent from '../commonComponents/TableParent';
import CallAPI from '../commonComponents/AxiosHelper';
import LoadingComponent from '../commonComponents/LoadingComponent';
import Form from '../commonComponents/Form';
import ErrorComponent from '../commonComponents/ErrorComponent';
import * as csv from 'csvtojson';
import DatasetFilter from '../commonComponents/DatasetFilter';
import QueryBuildComponent from '../commonComponents/QueryBuildComponent';

class RawComponent extends Component {

    constructor(props) {
        super(props);

        this.state = {
            metric: null,
            raw_data: null,
            dataCount: 0,
            clearFlag: null,
            defaultFormula: {
                "sum": { "name": "Sum", "value": "sum", },
                "avg": { "name": "Average", "value": "avg" },
                "None": { "name": "None", "value": "" },
            },
            isDerived: {
                "0": { name: "Default", value: "0" },
                "2": { name: "Derived", value: "2" },
                "1": { name: "Underlying", value: "1" }
            },
            isDisplay: {
                "1": { name: "Show", value: "1" },
                "0": { name: "Hide", value: "0" },
                "2": { name: "Delete", value: "2" }
            },
            value: 100

        };

        this.formData = {
            // "value": { "name": "value", "label": "colum", "type": "text" },
            "name": { "name": "name", "label": "Label", "type": "text" },
            "formula": {
                "name": "formula", "label": "Formula", "type": "text-large"
            }
        }

        this.bulkFormData = {
            "isDerived": {
                "name": "isDerived", "label": "Metric Type", "type": "dropdown", "options": [
                    // Don't change option needed
                    { "name": "Select Option", "value": "3" },
                    { "name": "Default", "value": "0", },
                    { "name": "Derived", "value": "2" },
                    { "name": "Underlying", "value": "1" },
                ]
            },
            "defaultFormula": {
                "name": "defaultFormula", "label": "Aggregation Type", "type": "dropdown", "options": [
                    { "name": "Select Option", "value": "3" },
                    { "name": "Sum", "value": "sum", },
                    { "name": "Average", "value": "avg" },
                    { "name": "None", "value": null },
                ]
            },
            "isDisplay": {
                "name": "isDisplay", "label": "Metric Display", "type": "dropdown", "options": [
                    { "name": "Select Option", "value": "3" },
                    { "name": "Show", "value": "1" },
                    { "name": "Hide", "value": "0" },
                    { "name": "Delete", "value": "2" },
                ]
            },
        }

        this.importFormData = {
            "fileImport": {
                "name": "fileImport", "label": "File Import", "type": "file"
            }
        }

        this.headerMapping = {
            "value": "Column Name",
            "name": "Name",
            "isDerived": "Metric Type",
            "formula": "Formulae",
            "defaultFormula": "Aggregation Type",
            "isDisplay": "Display"
        }
        this.buttons = {
            "dropdownConfig": [{
                "id": "id", "label": "More", "type": "dropdown", "display": true,
                "children": [
                    // { "id": "fileFormat", "label": "File Format Download", "action": "file" },
                    { "id": "exportCSV", "label": "Export CSV", "action": "export" },
                    // { "id": "importCSV", "label": "Import CSV", "action": "import" },
                ]
            }],
            "editButton": [{ "id": "editButton", "class": "", "label": "Edit", "type": "normal", "display": true, "action": "edit", 'modal_id': null }],
            "saveButton": [{
                "id": "saveButton", "class": "", "label": "Save", "type": "normal", "display": false, "action": "save", 'modal_id': null
            }],
            "cancelButton": [{ "id": "cancelButton", "class": "", "label": "Cancel", "type": "normal", "display": false, "action": "cancel", 'modal_id': null }]
        }


        this.change_handle = this.change_handle.bind(this);
        this.saveHandle = this.saveHandle.bind(this);
        this.change_table_format = this.change_table_format.bind(this);
        this.handleDataUpdate = this.handleDataUpdate.bind(this);
        this.text_to_json = this.text_to_json.bind(this);
        this.fetchRawData = this.fetchRawData.bind(this);
        this.submitHandle = this.submitHandle.bind(this);
        this.getJSON = this.getJSON.bind(this);
        this.handleLimitChange = this.handleLimitChange.bind(this);
        this.applyLimit = this.applyLimit.bind(this);
        this.setDataType = this.setDataType.bind(this);
    }

    componentWillMount() {
        if (this.state.raw_data == null || this.state.raw_data == undefined){
            this.fetchRawData();
        }                
    }

    componentDidUpdate(prevProps, nextState) {
        if (prevProps.datasetValue !== this.props.datasetValue) {            
            this.fetchRawData();
        }
    }

    fetchRawData(filter = null, limit = null) {
        this.setState({
            raw_data: null
        })
        let that = this;

        let searchParams = new URLSearchParams(location.search);

        let params = {
            siteId: localStorage.Dataset ? JSON.parse(localStorage.Dataset).siteId : null,
            // toolId: this.props.datasetValue
        }
        let post_data = {
            raw_table: searchParams.get("raw_data"),
            tableFlag: Number(searchParams.get("tableFlag"))
            // limit:5000
        }
        if(post_data.tableFlag == 1){
            params['toolId'] = searchParams.get("toolId");
        }

        if (filter !== null) {
            post_data['where'] = filter;
        }
        if (limit !== null) {
            post_data['limit'] = limit;
        }

        CallAPI('POST', '/app/table_view_db_manage_list', post_data, params, 0, function (response) {
            // that.setState({ raw_data: that.modifyDataFormat(response.data), raw_table: searchParams.get("raw_data") });
            that.setState({ raw_data: response, raw_table: searchParams.get("raw_data") });
        },this.props.authData)
    }

    modifyDataFormat  = (array_data) => {
        try {
            var that = this;
            let temp_array = [];
            array_data.map(function (innerData, index) {
                let inner_temp_array = [];
                
                Object.keys(innerData).map(function(val, ind) {
                    inner_temp_array[val] = innerData[val]
                });

                temp_array.push(inner_temp_array);
            })
            return { data: temp_array };
        } catch (e) {
            return "Error";
        }
    }

    componentDidMount() {
        jQuery(".custom-file-input").on("change", function () {
            var fileName = jQuery(this).val().split("\\").pop();
            jQuery(this).siblings(".custom-file-label").addClass("selected").html(fileName);
        });
    }

    change_table_format(array_data) {

        try {
            var that = this;
            let temp_array = [];
            array_data.map(function (innerData, index) {

                let inner_temp_array = [];

                innerData.isDerived = (innerData.isDerived).toLowerCase();

                inner_temp_array.label = innerData.value ? innerData.value : innerData[that.headerMapping['value']];

                inner_temp_array.name = innerData.name ? innerData.name : innerData[that.headerMapping['name']];

                inner_temp_array.isDerived = innerData.isDerived ? that.state.isDerived[innerData.isDerived].name : innerData[that.headerMapping['isDerived']];

                inner_temp_array.formula = innerData.formula ? innerData.formula : innerData[that.headerMapping['formula']];

                inner_temp_array.defaultFormula = (innerData.defaultFormula == "") ? that.state.defaultFormula["None"].name : that.state.defaultFormula[innerData.defaultFormula].name;
                // inner_temp_array.defaultFormula = (innerData.defaultFormula || innerData.defaultFormula == "") ? that.state.defaultFormula[innerData.defaultFormula].name : that.state.defaultFormula[innerData.defaultFormula].None;

                inner_temp_array.isDisplay = innerData.isDisplay !== undefined ? that.state.isDisplay[innerData.isDisplay].name : innerData[that.headerMapping['isDisplay']];

                inner_temp_array.updated_by = innerData.updated_by;
                inner_temp_array.update_time = innerData.update_time;

                temp_array.push(inner_temp_array);

            })

            return { data: temp_array };
        } catch (e) {
            return "Error";
        }
    }

    // change form submit handle
    saveHandle(e) {
        let form_array = jQuery("#add_form").serializeArray();

        let paramArray = {}
        form_array.map(function (innerData) {
            paramArray[innerData.name] = innerData.value;
        })
        paramArray['value'] = paramArray['name'].trim().toLowerCase().split(' ').join('_');
        paramArray['isDerived'] = '2';
        paramArray['isDisplay'] = '1';
        paramArray['defaultFormula'] = '';
        paramArray['actualFormula'] = paramArray['formula'];

        let metric_array = this.state.metric

        metric_array.metric.unshift(paramArray);

        this.setState({ metric: metric_array })

        jQuery("#addContent").modal('toggle');
        jQuery("#addContent").trigger("reset");

        e.preventDefault();
        // this.TableParent.handleButton(null, 1);

    }

    // handle popout submit button
    change_handle(data) {

        let raw_data = this.state.raw_data.data;

        let final_value = data.value;

        if (this.state[data.colDef.field]) {
            Object.values(this.state[data.colDef.field]).map(function (innerData) {
                if (innerData.name == data.value) {
                    final_value = innerData.value;
                }
            })
        }

        let field = data.colDef.field == "label" ? "name" : data.colDef.field;

        // raw_data[data.rowIndex][field] = final_value;
        raw_data[data.node.id][field] = final_value;
        // raw_data[data.rowIndex]["rockmetric_update"] = true;
        raw_data[data.node.id]["rockmetric_update"] = true;
        if (typeof raw_data[data.node.id]["rockmetric_update_columns"] == "undefined") {
            raw_data[data.node.id]["rockmetric_update_columns"] = [field];
        } else raw_data[data.node.id]["rockmetric_update_columns"].push(field);

        raw_data[data.node.id]["rockmetric_update_columns"] = [...new Set(raw_data[data.node.id]["rockmetric_update_columns"])]
    }


    //For adding new Derived Metrics
    submitHandle(filterData) {
        let that = this;

        let searchParams = new URLSearchParams(location.search);

        let params = {
            siteId: localStorage.Dataset ? JSON.parse(localStorage.Dataset).siteId : null,
            toolId: this.props.datasetValue,
            raw_table: searchParams.get("raw_data"),
            email: this.props.authData.username
        }

        filterData = filterData ? filterData.sql : null;

        if (confirm("Please Confirm to Update!")) {
            var final_data = { "data": that.state.raw_data.data, "unique": that.state.raw_data.uniqueKeys };
            CallAPI('POST', '/app/update_raw_table', final_data, params, 0, function (response) {
                alert("Successfully Submitted");
                window.location.reload();
            },this.props.authData)
        }

    }


    exportFile(params) {
        gridOptions.api.shouldRowBeSkipped();
    }


    text_to_json(data) {
        let that = this;
        csv({
            output: "json",
            noheader: false,
            headers: Object.keys(this.headerMapping),
            // nullObject:true,
            colParser: {
                "isDerived": function (item, head, resultRow, row, colIdx) {
                    let metricType = that.getJSON(Object.values(that.state[head]));
                    return metricType[item] ? metricType[item] : null;
                },
                "isDisplay": function (item, head, resultRow, row, colIdx) {
                    let displayType = that.getJSON(Object.values(that.state[head]));
                    return displayType[item] ? displayType[item] : null;
                }
            }
        }).fromString(data)
            .then(function (result) {
                let metric = that.state.metric;

                metric.metric = [...result, ...metric.metric];
                that.setState({
                    metric: metric
                });
                // that.TableParent.handleButton(null, 1);
            })
    }


    handleDataUpdate(data) {
        let metric = this.state.metric;
        metric.metric = data;
        this.setState({
            metric: metric
        })
    }


    getJSON(data) {
        let result = {};
        data.map((element, i) => {
            result[element.name] = element.value;
        });
        return result;
    }

    handleLimitChange(e) {
        let value = e.target.value;
        jQuery("#limitNumber").val(value);
        // this.setState({
        //     value:value
        // })
    }

    applyLimit(e) {
        e.preventDefault();
        let value = jQuery("#limitNumber").val();
        this.fetchRawData(null, value);
    }

    setDataType(value){
        if(Number.isNaN(Number(value))){
            return 'string';
        }
        else{
            return 'number';
        }
    }
    addIcon = (params) => {
        var mainLabel = params.column.colDef.field;
        var value;
        let cellValue = JSON.parse(params.data[mainLabel])
        if (mainLabel == 'frequency') {
            if (cellValue != undefined && cellValue != "") {
                if (mainLabel == 'frequency' && params.colDef.headerName == 'Frequency') {
                    if (cellValue['freq_type'] == 'dates') {
                        value = '-'
                    } else {
                        let dayofMonth = cellValue['freq_type'] ? cellValue['freq_type'] : "";
                        if (dayofMonth == "") {
                            value = '-'
                        }
                        else {
                            value = ` ${dayofMonth != "" ? `<i class="far fa-calendar fa-lg mg-r-5"></i>${dayofMonth.charAt(0).toUpperCase() + dayofMonth.slice(1)} ` : ""}`
                        }
                    }
                }

                if (mainLabel == 'frequency' && params.colDef.headerName == 'Frequency Time') {
                    let time = cellValue['timeOfDay'] ? cellValue['timeOfDay'] : "";
                    if (time == "") {
                        value = '-'
                    } else
                        value = `${time !== "" ? ` <i class="far fa-clock fa-lg mg-r-5"></i>${time} ` : ""} `
                }
                return value
            }
            else {
                return 'Not Applied'
            }
        } else {
            let subscribeStatus = cellValue == 0 ? 'Unsubscribed' : "Subscribed"
            value = cellValue == 0 ? `${`<span><i class="fas fa-bell-slash"></i>  ${subscribeStatus}</span>  `} ` : `${`<span><i class="fas fa-bell"></i>  ${subscribeStatus}</span>  `}`
            return value
        }
    }
    render() {

        let that = this;
        if (this.state.raw_data) {
            // let final_data = this.setDataType(this.state.raw_data);
            let final_data = this.state.raw_data;

            if (final_data == "Error" || final_data.data.length == 0) {
                mainData = <ErrorComponent message="This Table has no data" />;
            } else {

                var firstColumn = null;
                var uniqueKeys = final_data.uniqueKeys;
                
                var color_pattern = final_data.information ? JSON.parse(final_data.information).colorPattern : {};
                color_pattern = color_pattern ? color_pattern : {};

                var columns_array = Object.keys(final_data.data[0]).map(function (innerData, index) {

                    let editableFlag = true;
                    let value = null;
                    if (final_data.data[index] !== null && final_data.data[index] !== undefined){
                        value = final_data.data[index][innerData];
                    }
                    let dataType = that.setDataType(value);
                    if (uniqueKeys !== null && uniqueKeys !== undefined) {
                        if (uniqueKeys.indexOf(innerData) != -1) {
                            editableFlag = false;
                        }
                    }
                    else {
                        editableFlag = false;
                    }

                    if (index == 0) {
                        firstColumn = innerData
                    }
                    let tempInformation = color_pattern[innerData] ? color_pattern[innerData] : null
                    return { label: innerData, value: innerData, editable: editableFlag,hide:false,dataType:dataType, information: tempInformation }
                });

                var mainData = <>
                    {/* <QueryBuildComponent filters={this.state.raw_data.data} tableName={this.state.raw_table} /> */}
                    {/* <div class="col-md-3 mg-t-20 w-50 col-lg-12">
                        <div class="form-group row">
                            <label for="limitNumber" class="d-flex justify-content-center align-item-center" style={{marginTop:"5px", width:"fit-content"}}>Limit : </label>
                            <div class="col-sm-10 col-lg-6 d-flex col-md-8 gap-2">
                                <input type="number" class="form-control" id="limitNumber" placeholder="100" name="limit" min="1" max="1000000" />
                                <button class="btn btn-sm btn-primary col-lg-4">Apply Limit</button>
                            </div>
                        </div>
                    </div> */}
                    <TableParent
                        data={final_data}
                        parentConfig={this.state}
                        columns_array={columns_array}
                        firstColumnShow={false}
                        firstColumn={firstColumn}
                        onCellChange={this.change_handle}
                        actionArray={null}
                        menuAction={this.handleMenuAction}
                        handleDataUpdate={this.handleDataUpdate}
                        saveHandle={this.saveHandle}
                        buttonConfig={this.buttons}
                        submitHandle={this.submitHandle}
                        importJSON={this.text_to_json}
                        rowSelection="single"
                        iconDisplay={this.addIcon}
                    />
                </>
            }
        }
        else {
            mainData = <LoadingComponent />;
        }

        return (
            <div className="">
                {/* <DatasetFilter /> */}
                <div className="col-md-12">
                </div>
                {mainData}
            </div>
        );
    }
}

export default RawComponent;